import { IActionButton } from '~shared/modules/addresses/models/action-button.model';

export const enum ADDRESS_ACTION_TYPE {
  setDefaultShipping = 'set-default-shipping',
  setDefaultBilling = 'set-default-billing',
  update = 'update',
  remove = 'remove',
}

export const ADDRESS_ACTION_LIST: IActionButton[] = [
  {
    label: 'REGULAR.FIELDS.SET_AS_DEFAULT_SHIPPING.LABEL',
    type: ADDRESS_ACTION_TYPE.setDefaultShipping,
  },
  {
    label: 'REGULAR.FIELDS.SET_AS_DEFAULT_BILLING.LABEL',
    type: ADDRESS_ACTION_TYPE.setDefaultBilling,
  },
  {
    label: 'REGULAR.CHANGE',
    type: ADDRESS_ACTION_TYPE.update,
  },
  {
    label: 'REGULAR.REMOVE',
    type: ADDRESS_ACTION_TYPE.remove,
  },
];
